SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_main_content')

module.exports = class MainContentComponent extends React.Component
  render: t.renderable ->
    t.div '.enterprise-dash-layout', =>
      t.div '.enterprise-dash-layout-sidebar', =>
        t.div '.js-sidebar-content'

      t.div '.enterprise-dash-layout-list', =>
        if @props.selectedTab == 'members' || @props.selectedTab == 'teams' || @props.selectedTab == 'teams/pending' || @props.selectedTab == 'boards/public'
          t.div '.indented-title.u-clearfix', =>
            t.div '.js-list-header-content .list-header'
            t.addElement React.createElement SearchComponent,
              onChange: @props.onSearchTermChange
              clearValue: @props.clearSearchValue
              placeholder: t.l(['search', @props.selectedTab])
              searchCount: @props.searchCount
              debounce: true

        t.div '.js-filters-content'
        t.div '.js-bulk-actions-content'
        t.div '.js-list-content.enterprise-dash-list'
        t.div '.js-teams-settings-content.teams-settings-content'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/main-content-component.coffee